import { render } from "./bodyText.vue?vue&type=template&id=36829901"
import script from "./bodyText.vue?vue&type=script&lang=js"
export * from "./bodyText.vue?vue&type=script&lang=js"

import "./bodyText.vue?vue&type=style&index=0&id=36829901&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__